<div *ngIf="isLoading || _loaderService._isMainLoading || _loaderService.isLanguageLoad" [ngClass]="_loaderService.isLanguageLoad ? 'overlay' : ''" class="loading" id="loader">
    <div class="bar2"></div>
</div>